import React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'

import Div from '@jarvis.oddle/core/components/Div/Div'
import Form from '@jarvis.oddle/core/components/Form'
import Modal from '@jarvis.oddle/core/components/Modal'

import { padding, paddingSizes } from '@jarvis.oddle/core/theme/default'
import { lightenOrDarken } from '@jarvis.oddle/core/tools/style'

import { redirect } from 'src/utils/routes'

const Container = styled(Div)`
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
`

// WORKAROUND: consider to create color mode for different modals
const StyledFlexContainer = styled(Modal.FlexContainer)`
  ${props => props.backgroundColor ? `
    &&& {
      border-radius: 0;
      max-height: 100%;
      height: 100%;
      width: 100%;
    }

    & > div {
      background-color: ${props.backgroundColor};

      &:nth-child(2) > div {
        background-color: ${props.backgroundColor};
      }

      &:nth-child(3) {
        margin-top: auto;
        box-shadow: none;

        & > button {
          background-color: ${props.buttonColor};
          color: ${props.backgroundColor};
        }

        & > button:hover {
          background-color: ${lightenOrDarken(props.buttonColor)};
        }
      }
    }
  ` : ``}
`

// WORKAROUND: this will prevent vertical scrolling in Modal Body
const StyledModalSection = styled(Modal.Section)`
  height: calc(100% - 10px);
  padding: ${padding[paddingSizes.small]};
  overflow-y: hidden;
`

const LanguageModalForm = ({
  modal,
  width,
  buttonText,
  backgroundColor,
  buttonColor,
  Header,
  Body
}: {
  modal: {
    show: boolean
    onClose: (handler?) => void
    onClosed: () => void
  }
  width: string
  buttonText: string
  backgroundColor?: string
  buttonColor?: string
  Header: JSX.Element
  Body: JSX.Element
}): JSX.Element => {
  const router = useRouter()
  const { locale } = router.query

  const handleSubmit = (values) => {
    if (values.locale !== locale) {
      const newAsPath = (router.asPath).replace(locale as string, values.locale)
      redirect({
        url: router.pathname,
        as: newAsPath,
        scroll: false
      })
    }
    modal.onClose()
  }

  /*
    Here we have different styles of ModalHeader in MobileSideNavigation & LanguageSelectionModal
    For now, we do not wrap Header with Modal.header
  */

  return (
    <Form initialValues={{ locale }} onSubmit={handleSubmit}>
      <Container width={width}>
        <StyledFlexContainer
          backgroundColor={backgroundColor}
          buttonColor={buttonColor}
        >
          {Header}
          <Modal.Body >
            <StyledModalSection >
              {Body}
            </StyledModalSection>
          </Modal.Body>
          <Modal.Footer>
            <Form.SubmitButton fullWidth buttonStyle='solid' buttonShape='round'>
              {buttonText}
            </Form.SubmitButton>
          </Modal.Footer>
        </StyledFlexContainer>
      </Container>
    </Form>
  )
}

export default LanguageModalForm
